import { useEffect } from "react";
import { getLogoutUrl } from "../authConfig";

export default function Logout() {
  useEffect(() => {
    console.log("🔴 Cerrando sesión…");

    // Limpiar tokens
    localStorage.removeItem("idToken");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");

    // Redirigir a Cognito logout
    window.location.href = getLogoutUrl();
  }, []);

  return <h2>Cerrando sesión...</h2>;
}
